export default __webpack_public_path__ + "static/media/logo1.4e44fabb.png";